// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__arBVj","contentMobile":"styles_contentMobile__iUCF2","contentDesktop":"styles_contentDesktop__wRP1H"};